import { render, staticRenderFns } from "./table_template_detail.vue?vue&type=template&id=5b432bcc"
import script from "./table_template_detail.vue?vue&type=script&lang=js"
export * from "./table_template_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports